import type { ABTestResult } from './getABTest';
import pushInDataLayer from '@/utils/pushInDataLayer';

const sendABTestAnalytics = (abTestResults: Omit<ABTestResult, 'elements'>) => {
  const { abTestId, abTestVariantId, abTestComponents } = abTestResults;
  if (abTestId && abTestVariantId) {
    pushInDataLayer({
      event: 'ab-test-page-visited',
      abtestValue: {
        id: abTestId,
        variantId: abTestVariantId,
      },
    });
  }

  if (abTestComponents.length > 0) {
    abTestComponents.forEach((component) => {
      pushInDataLayer({
        event: 'ab-test-component',
        abtestValue: {
          id: component.campaignId,
          variantId: component.variantId,
        },
      });
    });
  }
};

export default sendABTestAnalytics;
